import { DataContext } from "../../helper/HelperOne"
import NavBar from "../nav_bar/Navbar"
import CustomerCreate from "./CustomerCreate"
import { useState } from "react"

function Customer() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<CustomerCreate/>}
                menuId={2}
            />
        </DataContext.Provider>
    )
}

export default Customer